export default __webpack_public_path__ + "static/media/discover-diamond.616908a7.png";